import { Component, OnInit, OnDestroy, Output, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstDto, ReimporttargetLstInfo, Sgkc031aReqReImportTargetSearchInfoDto, Sgkc031aRequest, Sgkc032aReqFixempCspManagenoTableInfoDto, Sgkc032aRequest, Sgkc036aReqReImportTargetSearchInfoDto, Sgkc036aRequest, Sgkc037aReqFixempCspManagenoTableInfoDto, Sgkc037aRequest } from 'sg-api';
import { UsedSgkc031aService } from '../../services/used-sgkc031a.service';
import { UsedSgkc032aService } from '../../services/used-sgkc032a.service';
import { UsedSgkc036aService } from '../../services/used-sgkc036a.service';
import { UsedSgkc037aService } from '../../services/used-sgkc037a.service';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';

import { Router } from '@angular/router';
import { PreSelectBox } from '../../../../../sg-kc-shared/constants/preSelectBox';

/**
 * 確定使用量再取込画面
 * 
 * @export
 * @class Sgkc051dComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'app-sgkc051d.',
    templateUrl: './sgkc051d.component.html',
    styleUrls: ['./sgkc051d.component.scss'],
})
export class Sgkc051dComponent implements OnInit, OnDestroy {

    /** エラーメッセージリスト */
    @Output() errorMessageModelArray: Array<SgAriaMessage>;
    /** コード変換マスタから受け取るステータスのセレクトボックスデータ */
    @Output() statusList: PreSelectBox[] = [];
    /** 供給地点特定番号 */
    @Output() suppntSpno: string = '';
    /** 確定使用量再取込対象取得結果 */
    @Output() reimportTargetListResult: ReimporttargetLstInfo[];

    /** 確定使用量再取込全体のフォーム */
    @ViewChild(FormGroupDirective)
    formDir: FormGroupDirective;

    /** 確定使用量再取込検索条件格納フォーム */
    reimportUsageConditionForm: UntypedFormGroup;
    /** 表示フラグ */
    showResult: boolean = false;

    /** 購読を停止するためのSubject */
    private onDestroy$ = new Subject();

    /**
     * コンストラクタ
     * @param {Router} router
     * @param {UntypedFormBuilder} fb
     * @param {UsedSgkc031aService} usedSgkc031aService
     * @param {UsedSgkc032aService} usedSgkc032aService
     * @param {UsedSgkc036aService} usedSgkc036aService
     * @param {UsedSgkc037aService} usedSgkc037aService
     * @param {CodeConversionMstService} codeConversionMstServise
     * @param {CompleteDataService} completeDataService
     */
    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private usedSgkc031aService: UsedSgkc031aService,
        private usedSgkc032aService: UsedSgkc032aService,
        private usedSgkc036aService: UsedSgkc036aService,
        private usedSgkc037aService: UsedSgkc037aService,
        private codeConversionMstServise: CodeConversionMstService,
        private completeDataService: CompleteDataService) {

        this.reimportUsageConditionForm = this.fb.group({});
    }

    /**
     * コンポーネント生成処理
     * @memberof Sgkc051dComponent
     */
    ngOnInit(): void {

        // コード変換マスタを呼び出し
        this.codeConversionMstServise.getCodeConversionMst([
            "S100300", // 再取込処理ステータスコード
        ])
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(data => {
                this.statusList = this.getSelectBoxFromCodeConversionMst("S100300", data);
            }, error => {
            });
    }

    /**
     * コンポーネント破棄処理
     * @memberof Sgkc051dComponent
     */
    ngOnDestroy(): void {

        this.onDestroy$.next();
    }

    /**
     * 検索ボタン押下処理
     * @memberof Sgkc051dComponent
     */
    onClickSearch(): void {

        // 検索条件フォームを取得
        let conditionInfo = this.reimportUsageConditionForm.getRawValue().childReimportUsageConditionInfo;

        // 再取込処理ステータスコードを取得
        let statusCode = null;
        if (conditionInfo.status !== null && conditionInfo.status.length > 0) {
            statusCode = conditionInfo.status;
        }

        // 供給地点特定番号を取得
        this.suppntSpno = conditionInfo.suppntSpno;

        if (this.suppntSpno.length === 17) {

            // ガス検索API呼出
            const reImportTargetSearchInfo: Sgkc031aReqReImportTargetSearchInfoDto = {
                suppntSpno: this.suppntSpno, // 供給地点特定番号
                reimpTrnsts: statusCode // 再取込処理ステータスコード
            };
            const request: Sgkc031aRequest = {
                reImportTargetSearchInfo: reImportTargetSearchInfo
            };

            // ガス確定使用量再取込対象取得API 呼出
            this.usedSgkc031aService.searchGasReimportTargetlList(request)
                .subscribe(response => {
                    if (response) {
                        this.showResult = true;
                    }
                }, error => {
                });

            // 取得結果更新
            this.usedSgkc031aService.reimportTargetListChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(result => {
                    this.reimportTargetListResult = this.sortReimportTargetListResult(result);
                });

        } else {

            // 電気検索API呼出
            const reImportTargetSearchInfo: Sgkc036aReqReImportTargetSearchInfoDto = {
                suppntSpno: this.suppntSpno, // 供給地点特定番号
                reimpTrnsts: statusCode // 再取込処理ステータスコード
            };
            const request: Sgkc036aRequest = {
                reImportTargetSearchInfo: reImportTargetSearchInfo
            };

            // 電気確定使用量再取込対象取得API 呼出
            this.usedSgkc036aService.searchElecReimportTargetList(request)
                .subscribe(response => {
                    if (response) {
                        this.showResult = true;
                    }
                }, error => {
                });

            // 取得結果更新
            this.usedSgkc036aService.reimportTargetListChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(result => {
                    this.reimportTargetListResult = this.sortReimportTargetListResult(result);
                });
        }
    }

    /** 
     * 確定使用量再取込対象リストの日付形式を更新し、発生日の降順でソートする。
     * @memberof Sgkc051dComponent
     */
    sortReimportTargetListResult(resultList: ReimporttargetLstInfo[]): ReimporttargetLstInfo[] {

        resultList.forEach(result => {

            // 日付形式をYYYY/MM/DD または YYYY/MMに更新
            result.occureDate = this.formatDate(result.occureDate);
            result.targetYm = this.formatDate(result.targetYm);
            result.usageStartdate = this.formatDate(result.usageStartdate);
            result.usageEnddt = this.formatDate(result.usageEnddt);
        });

        return resultList.sort((a, b) => {
            const dateDiff =
                new Date(b.occureDate).getTime() -
                new Date(a.occureDate).getTime();

            if (dateDiff !== 0) return dateDiff;

            return Number(this.isReimportStatus(a.reimportTrnStatuscode)) - Number(this.isReimportStatus(b.reimportTrnStatuscode));
        });
    }

    /** 
     * 引数の日付をYYYY/MM/DD形式に更新
     * @memberof Sgkc051dComponent
     */
    formatDate(dateStr: string): string {

        const year = dateStr.slice(0, 4);
        const month = dateStr.slice(4, 6);
        const day = dateStr.slice(6, 8);

        if (dateStr.length === 8) {
            return year + '/' + month + '/' + day;
        }

        if (dateStr.length === 6) {
            return year + '/' + month;
        }

        return dateStr;
    }

    /** 
     * 活性・非活性判定 
     * @memberof Sgkc051dComponent
     */
    isReimportStatus(statusCode: string): boolean {

        // 取消済み、取込済みを除いたステータスリストから判定
        const targetStatusCodeList = ['0', '1', '2'];
        const filterStatusList = this.statusList.filter(dto => targetStatusCodeList.includes(dto.value));

        return !filterStatusList.some(
            dto => dto.value === statusCode
        );
    }

    /**
     * クリアボタン押下処理
     * @memberof Sgkc051dComponent
     */
    onClickClear(clearForm: UntypedFormGroup): void {

        // バリデーションの状態をリセット
        this.formDir.resetForm();
        this.reimportUsageConditionForm = clearForm;

        // 検索結果を非表示
        this.showResult = false;
    }

    /**
     * 登録ボタン押下処理
     * @memberof Sgkc051dComponent
     */
    onClickRegistration(event: ReimporttargetLstInfo[]): void {

        if (this.suppntSpno.length === 17) {

            // ガス登録API呼出
            let fixempCspManagenoTableInfoList: Array<Sgkc032aReqFixempCspManagenoTableInfoDto> = [];
            event.forEach(data => {

                const fixempCspManagenoTableInfo: Sgkc032aReqFixempCspManagenoTableInfoDto = {
                    fixempCspManageno: data.fixempCspManageno, // 確定使用量再取込管理通番号
                    reimportTrnStatuscode: data.reimportTrnStatuscode // 再取込処理ステータスコード
                };

                const isAddedInfo = fixempCspManagenoTableInfoList.some(
                    dto => dto.fixempCspManageno === fixempCspManagenoTableInfo.fixempCspManageno &&
                        dto.reimportTrnStatuscode === fixempCspManagenoTableInfo.reimportTrnStatuscode
                );

                if (!isAddedInfo) {
                    fixempCspManagenoTableInfoList.push(fixempCspManagenoTableInfo);
                }
            });

            const request: Sgkc032aRequest = {
                fixempCspManagenoTableInfoList: fixempCspManagenoTableInfoList
            };

            this.usedSgkc032aService.cancelGasUsageReimport(request)
                .subscribe(response => {
                    if (response) {

                        // 登録完了画面遷移
                        this.navigateToCompleteData();
                    }
                }, error => {
                });

        } else {

            // 電気登録API呼出
            let fixempCspManagenoTableInfoList: Array<Sgkc037aReqFixempCspManagenoTableInfoDto> = [];
            event.forEach(data => {

                const fixempCspManagenoTableInfo: Sgkc037aReqFixempCspManagenoTableInfoDto = {
                    fixempCspManageno: data.fixempCspManageno, // 確定使用量再取込管理通番号
                    reimportTrnStatuscode: data.reimportTrnStatuscode // 再取込処理ステータスコード
                };

                const isAddedInfo = fixempCspManagenoTableInfoList.some(
                    dto => dto.fixempCspManageno === fixempCspManagenoTableInfo.fixempCspManageno &&
                        dto.reimportTrnStatuscode === fixempCspManagenoTableInfo.reimportTrnStatuscode
                );

                if (!isAddedInfo) {
                    fixempCspManagenoTableInfoList.push(fixempCspManagenoTableInfo);
                }
            });

            const request: Sgkc037aRequest = {
                fixempCspManagenoTableInfoList: fixempCspManagenoTableInfoList
            };

            this.usedSgkc037aService.cancelElecUsageReimport(request)
                .subscribe(response => {
                    if (response) {

                        // 登録完了画面遷移
                        this.navigateToCompleteData();
                    }
                }, error => {
                });
        }
    }

    /**
     * 登録完了画面遷移
     * @memberof Sgkc051dComponent
     */
    navigateToCompleteData(): void {

        this.completeDataService.completeData = {
            title: '確定使用量再取込登録完了', // 画面タイトルを設定
            message: '確定使用量の再取込ステータスを登録しました。', // 画面に表示するメッセージを設定
            next: '/sgkc/sgkc051d', // OK押下時に遷移する画面
            koumokuList: [], // 画面に表示する情報
            queryParams: {},
        }

        this.router.navigate(['/sgkz003d']);
    }

    /** 
     * コード変換マスタから受け取るセレクトボックスデータを作成
     * @param {string} codeId
     * @returns {PreSelectBox[]}
     * @memberof Sgkc051dComponent
     */
    getSelectBoxFromCodeConversionMst(codeId: string, codeConversionMstMap: Map<string, Array<CodeConversionMstDto>>): PreSelectBox[] {

        let preSelectBoxList: PreSelectBox[] = [];
        let codeList: CodeConversionMstDto[] = [];

        if (codeConversionMstMap.has(codeId)) {

            codeList = codeConversionMstMap.get(codeId);
            if (codeList) {

                codeList.forEach(data => {
                    const select: PreSelectBox = { value: data.userCode, viewValue: data.hyojiCont, hyojiRowTurn: data.hyojiRowTurn };
                    preSelectBoxList.push(select);
                })
            }
        }

        return preSelectBoxList;
    }
}
